import isPropValid from "@emotion/is-prop-valid";
import pickProps from "./pickProps";
var pickValidProps = function pickValidProps(props) {
  return pickProps(props, isPropValid);
};
export default pickValidProps;